import React, { createContext, useContext, ReactNode } from 'react'

interface AppConfig {
  apiBaseUrl: string
  environment: string
  azureAd: {
    clientId: string
    tenantId: string
  }
  features: {
    enableChatbot: boolean
  }
}

// Ensure HTTPS for all API calls in production/demo
const ensureHttps = (url: string): string => {
  if (!url) return url;
  // Force HTTPS in production/demo environments
  if (import.meta.env.VITE_ENVIRONMENT !== 'development' && import.meta.env.VITE_ENVIRONMENT !== 'local') {
    return url.replace(/^http:\/\//i, 'https://');
  }
  return url;
};

const defaultConfig: AppConfig = {
  apiBaseUrl: ensureHttps(import.meta.env.VITE_API_BASE_URL || 'https://localhost:7001'),
  environment: import.meta.env.VITE_ENVIRONMENT || 'development',
  azureAd: {
    clientId: import.meta.env.VITE_AZURE_CLIENT_ID || '',
    tenantId: import.meta.env.VITE_AZURE_TENANT_ID || ''
  },
  features: {
    enableChatbot: import.meta.env.VITE_ENABLE_CHATBOT === 'true'
  }
}

const ConfigContext = createContext<AppConfig>(defaultConfig)

interface ConfigProviderProps {
  children: ReactNode
}

export const ConfigProvider: React.FC<ConfigProviderProps> = ({ children }) => {
  return (
    <ConfigContext.Provider value={defaultConfig}>
      {children}
    </ConfigContext.Provider>
  )
}

// eslint-disable-next-line react-refresh/only-export-components
export const useConfig = () => {
  const context = useContext(ConfigContext)
  if (!context) {
    throw new Error('useConfig must be used within a ConfigProvider')
  }
  return context
}